<template>
  <div class="col-md-12">
    <div class="row mt-4">
      <div class="col-md-12 mt-5">
        <h1 class="subTitlePage font-weight-normal">{{ $t('campaign.create.title') }}</h1>
        <h3 class="subTitlePage font-weight-normal mt-3">{{ $t('campaign.create.subTitle') }}</h3>
      </div>
    </div>
    <CSpinner v-if="loadingGetList" color="primary" style="width: 4rem; height: 4rem" class="mt-4" />
    <div v-else>
      <CAlert v-if="!hasAudience" color="purple-200" class="d-flex align-items-center w-100 mt-4">
        <CIcon class="text-primary" name="notificationAlert" :height="32" viewBox="0 0 32 32" />
        <CCol sm="8" class="my-2">
          <h2 class="font-lg mb-1 text-primary">{{ $t('campaign.create.missing-audience.title') }}</h2>
          <p class="font-md m-0 text-primary">{{ $t('campaign.create.missing-audience.description') }}</p>
        </CCol>
        <CCol class="text-right">
          <CButton :to="{ name: 'import-contacts' }" color="primary">{{ $t('campaign.create.missing-audience.button') }}</CButton>
        </CCol>
      </CAlert>
      <div class="row justify-content-md-center mt-4">
        <div class="col-md-12">
          <div class="row justify-content-center">
            <!-- TESTE -->
            <CCol sm="12" class="mb-4 mt-5">
              <CRow class="justify-content-center">
                <CCol sm="3">
                  <div class="box-choose-campaign" @click="openQuickSMSModal">
                    <CIcon style="margin-top: 12px !important" class="mt-2 mr-2" name="sms" :height="60" viewBox="0 0 32 32" />
                    <CIcon class="mt-2" name="cilSpeedometer" :height="60" />
                    <h5 class="box-title-choose-campaign mt-3 box-arpoone-style">{{ $t('campaign.create.quick-sms') }}</h5>
                  </div>
                  <span @click="redirectToQuickSMSReport" class="text-center w-100 d-block mt-3 text-primary redirect-underline cursor-pointer">{{
                    $t('campaign.create.quick-sms-report')
                  }}</span>
                </CCol>
                <CCol sm="3">
                  <div
                    class="box-choose-campaign"
                    :class="{ '--disabled': !hasAudience }"
                    @click="
                      link({
                        model: 'sms',
                        activeBlock: {
                          type: 'SMS',
                          indexChannel: null,
                        },
                      })
                    "
                  >
                    <CIcon style="margin-top: 12px !important" class="mt-2" name="sms" :height="60" viewBox="0 0 32 32" />
                    <h5 class="box-title-choose-campaign mt-3 box-arpoone-style">{{ $t('campaign.create.sms-campaign') }}</h5>
                  </div>
                </CCol>
                <CCol sm="3">
                  <div
                    class="box-choose-campaign"
                    :class="{ '--disabled': !hasAudience }"
                    @click="
                      link({
                        model: 'email',
                        activeBlock: {
                          type: 'email',
                          indexChannel: null,
                        },
                      })
                    "
                  >
                    <CIcon style="margin-top: 12px !important" class="mt-2" name="email" :height="60" viewBox="0 0 32 32" />
                    <h5 class="box-title-choose-campaign mt-3 box-arpoone-style">{{ $t('campaign.create.email-campaign') }}</h5>
                  </div>
                </CCol>
                <CCol sm="3">
                  <div
                    class="box-choose-campaign"
                    :class="{ '--disabled': !hasAudience }"
                    @click="
                      link({
                        model: 'sms+email',
                        activeBlock: {
                          type: 'sms',
                          indexChannel: null,
                        },
                      })
                    "
                  >
                    <CIcon style="margin-top: 12px !important" class="mt-2 mr-2" name="sms" :height="60" viewBox="0 0 32 32" />
                    <CIcon class="mt-2" name="email" :height="60" viewBox="0 0 32 32" />
                    <h5 class="box-title-choose-campaign mt-3 box-arpoone-style">{{ $t('campaign.create.sms-email-campaign') }}</h5>
                  </div>
                </CCol>
              </CRow>
            </CCol>
            <!-- TESTE -->
          </div>
          <!--<div class="row" style="margin-left: 11%">
            <div class="col">
              <p class="pl-3">{{ $t('campaign.create.text-custom-campaign-from-scratch') }}</p>
  
              <a
                class="btn btn-white font-sm py-3 px-5 text-gray-700 ml-3 text-uppercase"
                @click.prevent="link({ model: 'custom', activeBlock: { indexChannel: null } })"
              >
                {{ $t('campaign.create.custom-campaign') }}
              </a>
            </div>
          </div>-->
        </div>
      </div>
    </div>
    <QuickSMSModal ref="quickSMSModal" />
  </div>
</template>

<script>
import EmptyList from '@/components/EmptyList'
import services from '../campaign-services'
import { getModels } from './../templates/models.js'
import QuickSMSModal from '../components/QuickSMSModal'

export default {
  name: 'ChooseCampaign',
  components: {
    EmptyList,
    QuickSMSModal,
  },
  data() {
    return {
      loadingGetList: false,
    }
  },

  created() {
    this.loadingGetList = true
    localStorage.removeItem('campaign')
  },

  mounted() {
    this.loadingGetList = false
  },

  computed: {
    hasAudience() {
      return this.$store.state.audience.hasAudience
    },
  },

  methods: {
    async gethasAudience() {
      const teste = await this.$store.dispatch('audience/hasAudience', this.$store.state.auth.user.organizationId)
    },

    link(params) {
      this.setMainCampaign({})
      try {
        this.setMainCampaign(getModels(params.model))
        this.setChannelInitial(params.activeBlock)
      } catch (error) {
        console.log(error)
      }

      this.$router.push({ name: 'campaignCreatorStart' })
    },

    getChannels() {
      services
        .getChannels(this.$route.params.organizationId)
        .then(() => {})
        .catch(() => {})
        .finally(() => {})
    },

    setMainCampaign(campaign) {
      this.$store.dispatch('campaign/setMainCampaign', campaign)
    },

    setChannelInitial(setChannel) {
      this.$store.dispatch('campaign/setCurrentChannel', setChannel)
    },

    openQuickSMSModal() {
      this.$refs.quickSMSModal.openModal()
    },

    redirectToQuickSMSReport() {
      this.$router.push({ name: 'logs-trasactions', query: { tab: 'sms' } })
    },
  },
  watch: {
    hasAudience: {
      handler() {
        this.loadingGetList = false
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.redirect-underline {
  font-size: 18px;
  text-decoration: underline;
}
</style>

<style lang="scss">
.chooseCampaignTitle {
  color: #22252b;
  font-size: 26px;
}

.chooseCampaignSubTitle {
  font-size: 20px;
}

.box-choose-campaign {
  width: 100%;
  height: 280px;
  border-radius: 2px;
  border: solid 3px #ffffff;
  cursor: pointer;
  text-align: center;
  padding-top: 20%;
  color: #8b65b3;
  background-color: #f7f5fa;

  &.--disabled {
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.5;
  }
}

.box-choose-campaign:hover {
  background-color: #e7e1f0;
}

.box-title-choose-campaign {
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.22;
  letter-spacing: 0.58px;
  text-align: center;
  color: #22252b;
  margin-bottom: 5px;
}

.box-arpoone-style {
  font-weight: 600;
  color: #343a40;
}

.icon-choose-campaign:hover {
  color: #ff5924;
}
</style>
